/* eslint-disable no-console */
import { takeLatest, all } from "redux-saga/effects";
import { supportActionConstants } from "../actions";
import { _sharedWorkerFetchCF, _sharedWorkerSendCF } from "@/shared/store/support/saga";

const TAG = "SUPPORT_SAGA";

export default function* contentSaga() {
  yield all([
    takeLatest(supportActionConstants.FETCH_CF, _sharedWorkerFetchCF),
    takeLatest(supportActionConstants.SEND_CF, _sharedWorkerSendCF),
  ]);
}
